import React from "react";
import { LegalLayout, H, P, Callout, UL } from "@/components/LegalLayout";
import { SITE } from "@/data/content";
import { legalBusinessIdentity } from "@/data/legalBusinessIdentity";

export default function RefundCancellationPolicy() {
  return (
    <div data-testid="refund-cancellation-policy-page">
    <LegalLayout
      title="Refund & Cancellation Policy"
      subtitle="Current cancellation, refund, and billing-correction rules for MySiteCare services"
      updated="September 2026"
    >
      <P>
        This policy summarizes the current cancellation and refund rules for MySiteCare services. Your accepted order,
        quotation, invoice, and Terms & Conditions remain part of the service relationship. If they differ, the
        accepted order and Terms & Conditions apply to that specific service, subject to applicable law.
      </P>

      <H>Subscription cancellation</H>
      <P>
        You may request cancellation before the next renewal date unless your accepted order states a different minimum
        term or notice period. Cancellation normally takes effect at the end of the current paid billing period.
      </P>
      <Callout>
        A billing period that has already started is normally not refunded merely because the Client changes their mind.
        Cancellation does not remove amounts already due or automatically transfer website ownership.
      </Callout>

      <H>One-time work and Website Ownership</H>
      <P>
        If a Website Ownership project is cancelled before work begins, MySiteCare may refund amounts paid after
        deducting non-recoverable third-party costs and reasonable administrative costs. Once work has begun, payment
        may be retained for completed work, time spent, third-party costs incurred, and committed project resources.
      </P>

      <H>When a refund or correction may apply</H>
      <UL items={[
        "A duplicate, incorrect, or unauthorized charge is confirmed.",
        "MySiteCare materially fails to provide an agreed paid service.",
        "A refund or credit is expressly agreed in writing.",
        "A refund, correction, re-performance, price reduction, or other remedy is required by applicable law.",
      ]} />
      <P>
        Refund timing and method can depend on the payment provider, bank, payment method, accounting process, and
        applicable law.
      </P>

      <H>How to request a billing review</H>
      <P>
        Email <a href={`mailto:${SITE.email}`} className="text-[#10B981] hover:underline">{SITE.email}</a> promptly
        with your name, business name, invoice number, payment proof, and a short explanation. MySiteCare will review
        the accepted order, payment records, work completed, and applicable rules.
      </P>

      <H>Business identity and contact</H>
      <P data-testid="refund-policy-business-identity">
        {legalBusinessIdentity.formalBusinessName} operates publicly as MySiteCare, a Philippine sole proprietorship.
        Registered / Business Address: {legalBusinessIdentity.registeredBusinessAddress}. Customer service: {SITE.email}.
      </P>
    </LegalLayout>
    </div>
  );
}